import { h, Component } from 'preact';
import { observer } from 'mobx-preact';
import { route } from 'preact-router';

import style from './style.css';

const initialState = {};

@observer
class TagLine extends Component {
    render() {
        const { tag, queryFilter, onClickTag, editTag, parent, children } = this.props;
        const isSelected = queryFilter.parent === tag.id || parent === tag.id;

        return (
            <div class='nav-item'>
                <div class={`${style.pointerCursor} nav-link py-0 ${isSelected ? 'active' : ''}`}>
                    <span onClick={() => onClickTag(tag.id)}>
                        <small class='float-right'>
                            {tag.filter ? <i class='fas fa-filter ml-1' /> : ''}
                            {tag.menu ? <i class='fas fa-bars ml-1' /> : ''}
                            {tag.pinned ? <i class='fas fa-thumbtack ml-1' /> : ''}
                        </small>
                        <small>
                            <i class={`fas fa-edit mr-1 text-${isSelected ? 'light' : 'primary'} primary font-weight-lighter`}
                                data-params={JSON.stringify({
                                    id: tag.id,
                                })}
                                onClick={editTag}
                            />
                        </small>
                        <i class={`fas fa-folder${isSelected ? '-open' : ''} mr-1`} />
                        {tag.name}
                        {tag.countChildren && <span class='font-weight-lighter ml-2'>({tag.countChildren})</span>}
                    </span>
                </div>
                {isSelected && <div class={`d-${isSelected ? 'block' : 'none'} nav flex-column mt-1 ml-4`}>
                    <TagList
                        tags={children}
                        queryFilter={queryFilter}
                        onClickTag={onClickTag}
                        editTag={editTag}
                    />
                </div>}
            </div>
        );
    }
}

@observer
class TagList extends Component {
    render() {
        const { tags, queryFilter, onClickTag, editTag, parent, children } = this.props;
        return (
            <div>
                {tags.map(tag => <TagLine
                    tag={tag}
                    queryFilter={queryFilter}
                    onClickTag={onClickTag}
                    editTag={editTag}
                    children={children}
                    parent={parent}
                />)}
            </div>
        );
    }
}

@observer
class TagTree extends Component {
    constructor(props) {
        super(props);
        this.state = { ...initialState };

        const { tagStore } = this.props.stores;
        const { queryFilter } = tagStore;
        tagStore.load('', false, { dataKey: 'tagTree', query: { hasParent: 0 } });
        tagStore.load('', false, { dataKey: 'tagTreeBranchPinned', query: { pinned: 1 } });
        if (queryFilter.parent) {
            tagStore.load('', false, { dataKey: 'tagTreeBranch', query: { parent: queryFilter.parent, limit: 200 } });
        }
    }

    onClickTag = (parentId) => {
        const { tagStore } = this.props.stores;
        // tagStore.toggleQueryfilter('mainCat', '', { setValue: 1, skipUpdate: 1 });
        tagStore.updateKeyValue('tagTreeBranch', []);
        tagStore.toggleQueryfilter('parent', parentId, { setValue: true });
        tagStore.load('', false, { dataKey: 'tagTreeBranch', query: { parent: parentId, limit: 200 } });
    }

    editTag = (event) => {
        event.stopPropagation();
        const { params } = event.target.dataset;
        const inputParams = JSON.parse(params || {});
        const { id } = inputParams;
        route(`/tags/${id}/Basics`, true);
    }

    render(props = this.props) {
        const { tagStore } = props.stores;
        const { tagTree, tagTreeBranch, tagTreeBranchPinned, tagTreeParent, queryFilter } = tagStore;
        const isSelected = !queryFilter.parent;

        return (
            <div class='nav flex-column nav-pills'>
                <div class='nav-item mb-4 pb-4' style='border-bottom: 1px solid;'>
                    <div class={`${style.pointerCursor} nav-link py-0 ${isSelected ? 'active' : ''}`}>
                        <span onClick={() => this.onClickTag(null, { open: true })}>
                            ALL TAGS
                        </span>
                    </div>
                </div>

                <div class='mb-4 pb-4' style='border-bottom: 1px solid;'>
                    PINNED TAGS: <br />
                    <TagList
                        className={'font-weight-bold'}
                        tags={tagTreeBranchPinned}
                        queryFilter={queryFilter}
                        onClickTag={this.onClickTag}
                        editTag={this.editTag}
                    />
                </div>

                <TagList
                    tags={tagTree}
                    queryFilter={queryFilter}
                    onClickTag={this.onClickTag}
                    editTag={this.editTag}
                    children={tagTreeBranch}
                    parent={tagTreeParent}
                />
            </div>
        );
    }
}

export default TagTree;



// WEBPACK FOOTER //
// ./components/tags/tree.js